export const convertToURI = (name) => {
	if (!name) return '';
	return name
		.replace(/ /g, '-')
		.replace(/-+/gi, '-')
		.replace(/\?/g, '')
		.toLowerCase()
		.trim();
};
